import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/marketing/edit.svg'


const _hoisted_1 = { class: "top-box" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "iconfont icon-baocuo"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"color":"#f50"} }
const _hoisted_6 = { key: 1 }

import type { TreeProps } from 'ant-design-vue'
import { ref, watch } from 'vue'
import type { PropType } from 'vue'
import { PlusCircleOutlined } from '@ant-design/icons-vue'
// import { DcConfirm, DcMessage } from '@dc-platform/dc-components'
// import { SaveServiceParamParams } from '@/typings/api/systemSetting'
// import { deleteServiceParam } from '@/api/systemSetting/index'
import type { EventDataNode, DataNode } from 'ant-design-vue/es/tree'
import changeAddBtn from '../hooks/changeBtnToTree'
import addBackgroundClass from '../hooks/addBackgroundClass'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'Tree',
  props: {
  treeData: {
    type: Array as PropType<TreeProps['treeData']>,
    default: () => []
  },
  dataSource: {
    type: Array,
    default: () => []
  },
  searchData: {
    type: Object,
    default: () => {
      return {}
    }
  },
  checkable: {
    type: Boolean,
    default: true
  },
  checkedKeys: {
    type: Array as PropType<string[]>,
    default: () => []
  }
},
  emits: ['selectTreeData', 'emptyTreeData', 'addNewService', 'successRefresh', 'showEditEmit'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props
const emit = __emit

const selectedKeys = ref<string[]>([])
const treeDataComputed = ref()
const nowExpandIdArr = ref([])
watch(
  () => props.treeData,
  (val) => {
    treeDataComputed.value = val
    isExpandAddClass(nowExpandIdArr.value, treeDataComputed.value)
    if (showEdit.value) {
      showAddBtn(treeDataComputed.value)
    }
  }
)
// 列选中

// 复选框选中
const onCheck = (
  checkedKey: any,
  info: { event: 'select'; selected: boolean; node: EventDataNode; selectedNodes: DataNode[]; nativeEvent: MouseEvent }
) => {
  if (checkedKey.length > 0) {
    emit('selectTreeData', info.node.id)
  } else {
    emit('emptyTreeData')
  }
  // 整合checkedKeys
}

// 搜索
const searchValue = ref<string>('')
const expandedKeys = ref<(string | number)[]>([])
const autoExpandParent = ref<boolean>(true)
const gData = ref<TreeProps['treeData']>()
// 添加背景色class
const { isExpandAddClass, removeExpandClass } = addBackgroundClass()

const onExpand = (keys: any) => {
  nowExpandIdArr.value = keys
  isExpandAddClass(keys, treeDataComputed.value)
  removeExpandClass(keys, treeDataComputed.value)
  expandedKeys.value = keys
  autoExpandParent.value = false
}
const dataList: TreeProps['treeData'] = []
const generateList = (data: TreeProps['treeData']) => {
  if (data) {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const key = node.key
      dataList.push({ key, name: node.name })
      if (node.children) {
        generateList(node.children)
      }
    }
  }
}
watch(props, () => {
  generateList(treeDataComputed.value)
  gData.value = props.treeData
})

const getParentKey = (key: string | number, tree: TreeProps['treeData']): string | number | undefined => {
  let parentKey
  if (tree) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
  }

  return parentKey
}
watch(searchValue, (value) => {
  if (!searchValue.value) {
    autoExpandParent.value = false
    return
  }

  const expanded: any = dataList
    .map((item) => {
      if (item.name && item.name.indexOf(value) > -1) {
        return getParentKey(item.key, gData.value)
      }
      return null
    })
    .filter((item, i, self) => item && self.indexOf(item) === i)
  nowExpandIdArr.value = expanded
  if (expanded) {
    const arr: any = []
    expanded.forEach((item: string | number) => {
      if (getParentKey(item, gData.value)) {
        arr.push(getParentKey(item, gData.value))
      }
    })
    isExpandAddClass(expanded, treeDataComputed.value)
    console.log('expanded: ', expanded)

    removeExpandClass(expanded, treeDataComputed.value)
    console.log('treeDataComputed.value: ', treeDataComputed.value)
    expandedKeys.value = expanded
  }
  searchValue.value = value
  autoExpandParent.value = true
})
// 第一层新增
const handleParentAdd = () => {
  if (newClassKey.value === -1) {
    newClassKey.value = ''
    selectedKeys.value = []
    emit('emptyTreeData')
  } else {
    newClassKey.value = -1
    selectedKeys.value = []
    emit('addNewService', { data: { id: -1 } })
  }
}
// 新增
const newClassKey = ref()
watch(selectedKeys, () => {
  if (selectedKeys.value.length > 0) {
    newClassKey.value = null
  }
})
const addNewService = (dataRef: any) => {
  console.log('dataRef: ', dataRef)
  if (newClassKey.value === dataRef.key) {
    newClassKey.value = ''
    selectedKeys.value = []
    emit('emptyTreeData')
  } else {
    newClassKey.value = dataRef.key
    selectedKeys.value = []
    emit('addNewService', dataRef)
  }
}
// 编辑
const showEdit = ref<boolean>(false)
const { showAddBtn, removeAddBtn } = changeAddBtn()

const handleEdit = () => {
  if (showEdit.value) {
    treeDataComputed.value = removeAddBtn(treeDataComputed.value)
    cleanFirstLevelClass(treeDataComputed.value)
    showEdit.value = false
    emit('showEditEmit', showEdit.value)
    // DcConfirm.warning({
    //   title: '操作提示！',
    //   content: '信息更改还没有保存，确认是否离开',
    //   cancelText: '取消',
    //   okText: '继续',
    //   onOk: () => {
    //     treeDataComputed.value = removeAddBtn(treeDataComputed.value)
    //     cleanFirstLevelClass(treeDataComputed.value)
    //     showEdit.value = false
    //     emit('showEditEmit', showEdit.value)
    //   }
    // })
  } else {
    showEdit.value = false
    showAddBtn(treeDataComputed.value)
    showEdit.value = true
  }
  emit('showEditEmit', showEdit.value)
}
// 去除第一层级（且没有children）的数据的背景颜色class
const cleanFirstLevelClass = (arr: any) => {
  arr.forEach((item: any) => {
    if (item.children.length === 0 && item.parentId === -1) {
      item.class = ''
    }
  })
}
// 删除
// const handleDelete = async (dataRef: SaveServiceParamParams) => {
//   DcConfirm.warning({
//     title: '操作提示！',
//     content: '本操作不可恢复，请谨慎操作！',
//     cancelText: '取消',
//     okText: '确认',
//     onOk: () => {
//       deleteMethod(dataRef)
//       // try {
//       //   console.log(dataRef)
//       // } catch (error) {
//       //   console.log('handleDelete error: ', error)
//       // }
//     }
//   })
// }
// const deleteMethod = async (dataRef: SaveServiceParamParams) => {
//   try {
//     await deleteServiceParam({
//       paramId: dataRef.id
//     })
//     emit('successRefresh')
//     DcMessage.success('删除成功！')
//   } catch (error) {
//     console.log('deleteMethod error: ', error)
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_input, {
        value: searchValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        style: {"margin-bottom":"8px"},
        placeholder: _unref(t)('system.2wy1yg')
      }, null, 8, ["value", "placeholder"]),
      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        class: _normalizeClass([{ 'no-border': showEdit.value }, "btn-edit"]),
        onClick: handleEdit
      }, {
        icon: _withCtx(() => [
          (!showEdit.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("span", _hoisted_3))
        ]),
        _: 1
      }, 8, ["class"])), [
        [_directive_permission, 'base_applyservice_edit_btn']
      ])
    ]),
    _createVNode(_component_a_tree, _mergeProps(_ctx.$attrs, {
      selectedKeys: selectedKeys.value,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
      showIcon: false,
      checkable: false,
      "tree-data": treeDataComputed.value,
      onSelect: onCheck,
      autoExpandParent: autoExpandParent.value,
      "expanded-keys": expandedKeys.value,
      onExpand: onExpand
    }), {
      title: _withCtx(({ dataRef, name }) => [
        (dataRef.type && dataRef.type == 'add')
          ? _renderSlot(_ctx.$slots, "title", { key: 0 }, () => [
              _createElementVNode("div", {
                style: {"height":"150px"},
                onClick: _withModifiers(($event: any) => (addNewService(dataRef)), ["stop"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["add-or-delete-box", [dataRef.key == newClassKey.value ? 'select-add' : '']])
                }, [
                  _createVNode(_unref(PlusCircleOutlined), {
                    class: _normalizeClass([dataRef.key == newClassKey.value ? 'select-img' : ''])
                  }, null, 8, ["class"]),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('btn.add')), 1)
                ], 2)
              ], 8, _hoisted_4)
            ])
          : _renderSlot(_ctx.$slots, "title", { key: 1 }, () => [
              _createElementVNode("div", {
                class: _normalizeClass([dataRef.children && dataRef.children.length ? 'has-tree-child' : 'no-tree-child'])
              }, [
                (name && name.indexOf(searchValue.value) > -1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: _normalizeStyle({ color: dataRef.status === 1 ? '#ccc' : '#132043d9' })
                    }, [
                      _createTextVNode(_toDisplayString(name.substr(0, name.indexOf(searchValue.value))) + " ", 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(searchValue.value), 1),
                      _createTextVNode(" " + _toDisplayString(name.substr(name.indexOf(searchValue.value) + searchValue.value.length)), 1)
                    ], 4))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(name), 1))
              ], 2)
            ])
      ]),
      _: 3
    }, 16, ["selectedKeys", "tree-data", "autoExpandParent", "expanded-keys"]),
    (showEdit.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["add-or-delete-box", [-1 === newClassKey.value ? 'select-add' : '']]),
          style: {"margin-top":"10px"},
          onClick: handleParentAdd
        }, [
          _createVNode(_unref(PlusCircleOutlined), {
            class: _normalizeClass([-1 === newClassKey.value ? 'select-img' : ''])
          }, null, 8, ["class"]),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('btn.add')), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})